import qs from 'qs';

export default params => qs.stringify(params, { arrayFormat: 'brackets' });
